import { Deregistration } from "./";
import { BaseBackoffice } from "./tasks";

export class DeregistrationBackoffice extends Deregistration {
    constructor() {
        super();
        this.backoffice = Object.assign({}, new BaseBackoffice());
    }
}
